import "./edit-util-category.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilCategory from "../form-util-category/form-util-category";
import { useEditUtilCategory } from "./edit-util-category.hook";

export function EditUtilCategory() {
  const {
    utilCategoryData,
    isLoading,
    utilCategoryError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditUtilCategory();

  const title = utilCategoryData?.name ? (
    <h1>{utilCategoryData?.name}</h1>
  ) : (
    <h1>Edit Category</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormUtilCategory />
      </section>
    </div>
  );

  return (
    <div id="EditUtilCategory" className="util-category">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {utilCategoryError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditUtilCategory;
